import script from "./nav.vue?vue&type=script&setup=true&lang=js"
export * from "./nav.vue?vue&type=script&setup=true&lang=js"

import "./nav.vue?vue&type=style&index=0&id=5338a428&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5338a428"]])

export default __exports__